/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-07-06 09:44:55
 */
const state = {
  screenForm: {}, // 充电站的页面搜索条件
  isScreenForm: false // 是否选择了条件

};

// 筛选数据、改变状态的方法
const getters = {

};
// 同步操作 是变更参数的方法
const mutations = {

  set_screenForm(state, data) {
    state.screenForm = data;
  },
  ser_isScreenForm(state, status) {
    state.isScreenForm = status;
  }
};

// 异步操作
const actions = {
  

};

export default {
  state,
  mutations,
  actions,
  getters
};
